import { getLocaleDateFormat } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, NavigationEnd, NavigationStart, Router } from '@angular/router';
import { DataService } from 'src/app/_services/data.service';
import { slideRight, slideUp, anim, changeDivSize } from 'src/app/animations';
import { Title } from '@angular/platform-browser';

@Component({
  selector: 'app-n-show-gallery',
  templateUrl: './n-show-gallery.component.html',
  styleUrls: ['./n-show-gallery.component.scss'],
  host: {
    '[@slideRight]': ''
  }
})
export class NShowGalleryComponent implements OnInit {
  section: string = '';
  projid;
  proj;
  title: string;
  compTitle:string = '';

  constructor(
    private dataService: DataService,
    private route: ActivatedRoute,
    private router: Router,
    private titleService: Title
  ) {}

  ngOnInit(): void {
    // switch (window.location.host) {
    //   case 'getkey1.online':
    //     this.compTitle = 'Get Key 1';
    //     break;
    //   case 's-katorza.com':
    //     this.compTitle = 'S. Katorza';
    //     break;
    //   case 'spirical.net':
    //     this.compTitle = 'Spirikal';
    //     break;
    //   default:
    // }
    this.compTitle = this.dataService.hoisUrlGetTitle();
    this.route.params.subscribe(params => {
      this.section = params.section;
      this.paramsChange(params.section);
    });
    this.title = this.compTitle + '- גלריות';
    this.titleService.setTitle(this.title);
  }


  paramsChange(section) {
    this.section = section;
  }

}